import { EImportSectionsTarget } from '@constants';
import { ISection } from '@sdk/contracts';
import { Button, Flex, Popover, Tooltip, message } from 'antd';
import { useTranslation } from 'react-i18next';

import { EditSection } from '../EditSection';

import { RemoveBaseContentSection } from './RemoveBaseContentSection';
import { PopoverWrapper } from './SectionActions.styles';

import { Icon } from '@/components/Icon';
import { RemoveSection } from '@/components/RemoveSection';

type SectionActionsProps = {
  courseId: string;
  section: ISection;
  target: EImportSectionsTarget;
};

export const SectionActions: React.FC<SectionActionsProps> = ({ target, section, courseId }) => {
  const { t } = useTranslation('CourseTranslations');

  return (
    <Flex>
      <EditSection target={target} section={section} />

      <Tooltip title={t('COPY_SECTION_ID')}>
        <Button
          type="text"
          size="large"
          icon={<Icon i="Copy" size={20} />}
          onClick={e => {
            e.stopPropagation();
            navigator.clipboard.writeText(section._id);
            message.success(t('SECTION_ID_COPIED', { name: section.name }));
          }}
        />
      </Tooltip>

      <Popover
        placement="right"
        trigger="click"
        content={
          <PopoverWrapper>
            {(section.syncedSections ?? []).length > 0 ? (
              <RemoveBaseContentSection courseId={courseId} section={section} />
            ) : (
              <RemoveSection courseId={courseId} section={section} />
            )}
          </PopoverWrapper>
        }>
        <span onClick={e => e.stopPropagation()}>
          <Button size="large" type="text" icon={<Icon i="OverflowMenuVertical" size={20} />} />
        </span>
      </Popover>
    </Flex>
  );
};
